export const RING_SIZE_MM = 'MM';
export const RING_SIZE_US = 'US';
export const CURRENCY_USD = 'USD';
export const LOCAL_STORAGE_KEY = 'userRingMeasurementType';
export const RING_MEASUREMENT_TYPE_PARAM = 'ring-measurement-type';
export const RING_SIZE_FILTER_NAME = 'ring-size';

export type RingSize = typeof RING_SIZE_MM | typeof RING_SIZE_US;
